import React from 'react';
// ui
import { Typography } from 'rmwc/Typography';

const Photo = ({ img, caption, alt, root='./' }) => {
    return (
        <div className={'framedImageHolder'}>
            <div className={'framedImageHolder--inner'}>
                <img src={`${root}${img}`}
                     alt={alt ? alt : caption}/>
                <Typography use={'caption'} tag={'p'}>
                    {caption}
                </Typography>
            </div>
        </div>
    )
};

export default Photo;


// WEBPACK FOOTER //
// ./src/app/components/Photo.js